export default "__VITE_ASSET__505147fe__"